import {Component} from 'react';
import {reportErrorSentry} from '../util/tracking';
class ErrorBoundary extends Component {
  state = {hasError: false};

  static getDerivedStateFromError() {
    return {hasError: true};
  }

  componentDidCatch(error: Error) {
    reportErrorSentry(error);

    this.setState({hasError: true});
  }

  render() {
    if (this.state.hasError) {
      // TODO: error 발생시 fallback 화면을 보여주자.
      return null;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
